// extracted by mini-css-extract-plugin
export var four = "section-module--four--dfab5";
export var item = "section-module--item--6c069";
export var rootContent = "section-module--rootContent--50fd8";
export var rootItem = "section-module--rootItem--30c7d";
export var rootSection = "section-module--rootSection--46a6a";
export var rootTitle = "section-module--rootTitle--511d7";
export var three = "section-module--three--a8d0e";
export var two = "section-module--two--82b9e";